import useAPI, { useAPIMutation } from "@/services/api/hook";
import { CreateRecentSearchRequest } from "../types";

export const useRecentSearchQuery = () => {
  return useAPI("search/global/recent", {
    method: "GET"
  });
};

export const useCreateRecentSearchMutation = () => {
  return useAPIMutation<CreateRecentSearchRequest, void>(
    "search/global/recent/create",
    {
      method: "POST"
    }
  );
};
